import { EditIcon } from 'lucide-react';
import { useState } from 'react';
import { Background } from 'shared/constants/backgrounds';
import { UDText } from 'ud-ui/components';
import { BackgroundItem } from './background-item';
import { BackgroundPicker } from './background-picker';
import { EDIT_ICON_CLASS, EditIconSlot, Layout, PreviewFrame } from './styles';

interface LogoPreviewProps {
  img: string;
  background: Background;
  backgrounds: Background[];
  onChangeBackground: (background: Background) => void;
}

/**
 * Логотип на выбранном фоне; по клику — выбор другого фона.
 *
 * Два состояния в одном компоненте, потому что переключение между ними никого
 * снаружи не касается: форма узнаёт только про смену фона.
 */
export function LogoPreview({ img, background, backgrounds, onChangeBackground }: LogoPreviewProps) {
  const [isPicking, setIsPicking] = useState(false);

  if (isPicking) {
    return (
      <BackgroundPicker
        img={img}
        backgrounds={backgrounds}
        current={background}
        onApply={(picked) => {
          onChangeBackground(picked);
          setIsPicking(false);
        }}
        onCancel={() => setIsPicking(false)}
      />
    );
  }

  return (
    <Layout>
      <UDText type="footnote">Ваш логотип</UDText>
      <PreviewFrame role="button" tabIndex={0} aria-label="Изменить фон логотипа" onClick={() => setIsPicking(true)}>
        <BackgroundItem background={background} img={img} />
        <EditIconSlot className={EDIT_ICON_CLASS}>
          <EditIcon />
        </EditIconSlot>
      </PreviewFrame>
    </Layout>
  );
}
